export default {
  forgot_password: {
    title: 'パスワードリセット',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: 'パスワードをお忘れの方へ',
    password_reset_text: 'メールアドレスを入力＆送信ボタンを押すと確認メールが届きますので、パスワードリセット処理をお願いします。',
    submit: '送信する',
    mail_address: 'メールアドレスを入力してください',
    input_label: '@:settings.user.email',
  },
}
